import { createShigoApiClient, type ShigoApiConfig } from '../../../../lib/shigo-api-client';
import {
  networkDashboardOverviewSchema,
  networkDemandSourcesSchema,
  type NetworkDashboardOverview,
  type NetworkDemandSources,
} from './model';
import type { DashboardDateRange } from '@/components/dashboard/model';

interface NetworkDashboardClientOptions {
  config: ShigoApiConfig;
  accessToken: string;
  fetcher?: typeof fetch;
}

export function createNetworkDashboardClient({
  config,
  accessToken,
  fetcher,
}: NetworkDashboardClientOptions) {
  const api = createShigoApiClient(config, accessToken, fetcher);

  function reportPath(
    resource: 'report' | 'report-top5-dp',
    networkId: string,
    range: DashboardDateRange,
  ) {
    const base = `/api/sa-dash/network-overview/${resource}/${encodeURIComponent(networkId)}`;
    if (range.preset) {
      const search = new URLSearchParams({
        presetDateRange: range.preset,
        offsetCount: '0',
        offsetSize: '0',
      });
      return `${base}/${resource === 'report' ? 'overview-presets' : 'presets'}?${search.toString()}`;
    }
    const search = new URLSearchParams({ dateFrom: range.dateFrom, dateTo: range.dateTo });
    return `${base}?${search.toString()}`;
  }

  return {
    overview(networkId: string, range: DashboardDateRange): Promise<NetworkDashboardOverview> {
      return api.request({
        path: reportPath('report', networkId, range),
        schema: networkDashboardOverviewSchema,
      });
    },
    demandSources(networkId: string, range: DashboardDateRange): Promise<NetworkDemandSources> {
      return api.request({
        path: reportPath('report-top5-dp', networkId, range),
        schema: networkDemandSourcesSchema,
      });
    },
  };
}
